import { Link } from "react-router-dom";
import { IMAGES } from "@/lib/site";

const Hero = () => (
  <section
    id="hero"
    data-testid="hero-section"
    className="relative min-h-[90vh] flex flex-col justify-end text-white overflow-hidden"
  >
    <img
      src={IMAGES.hero}
      alt="Swimming pool at Raffiel Nias at dusk, overlooking the ocean at Sorake Beach"
      className="absolute inset-0 w-full h-full object-cover"
    />
    <div
      className="absolute inset-0"
      style={{
        background:
          "linear-gradient(to top, rgba(14,41,40,0.88) 0%, rgba(14,41,40,0.4) 60%, rgba(14,41,40,0) 100%)",
      }}
    />
    <div className="relative max-w-7xl mx-auto px-6 pb-16 pt-32 w-full z-10 anim-rise">
      <div className="max-w-3xl">
        <div className="flex items-center gap-3 mb-4">
          <span className="inline-block w-2.5 h-2.5 rounded-full bg-terracotta"></span>
          <p className="text-xs font-mono-clean uppercase tracking-widest text-sand-50/80">
            Directly on Sorake Beach · South Nias
          </p>
        </div>
        <h1 className="font-display text-4xl sm:text-6xl md:text-7xl font-bold tracking-tight leading-[1.05] text-white mb-6">
          Steps from the wave at Lagundri Bay.
        </h1>
        <p className="text-base sm:text-lg text-sand-50/90 leading-relaxed font-light mb-8 max-w-2xl">
          Beachfront accommodation at Sorake with pool, rooftop ocean-view café,
          surf photography, coaching, and reliable board shipment straight from
          Medan or Padang.
        </p>
        <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-4 pt-2">
          <Link
            to="/#contact"
            data-testid="hero-check-availability-button"
            className="inline-flex items-center justify-center px-8 py-4 rounded-xl font-medium text-sm text-ocean-900 bg-sand-50 hover:bg-white shadow-xl transition-colors"
          >
            Check Room Availability & Pricing
          </Link>
          <Link
            to="/board-transfer"
            data-testid="hero-board-shipment-button"
            className="inline-flex items-center justify-center px-6 py-4 rounded-xl font-medium text-sm text-white bg-white/10 backdrop-blur-md border border-white/20 hover:bg-white/20 transition-colors"
          >
            Organise Board Bag Shipment
          </Link>
        </div>
        <p className="text-xs text-sand-50/70 mt-3 font-mono-clean">
          Rooms from $45/night · Monthly stays from $700 · GuestPro direct rates
        </p>
      </div>
    </div>
  </section>
);

export default Hero;
